export const countryTypes = {
    UNITED_STATES: {label: "United States", code: "US"},
    CANADA: {label: "Canada", code: "CA"}
};

export const countryTypesArray = [
    countryTypes.UNITED_STATES,
    countryTypes.CANADA
];
